const init = {
  backgroundEffect: true,
  browser: false,
};

const settingsReducer = (state = { ...init }, action) => {
  switch (action.type) {
    case 'SET_BACKGROUND_EFFECT':
      return {
        ...state,
        backgroundEffect: action.backgroundEffect,
      };

    case 'SET_BROWSER':
      return {
        ...state,
        browser: action.browser,
      };

    default:
      return state;
  }
};

export default settingsReducer;
